import { action, observable, computed, makeObservable } from 'mobx';
import { Comment } from './comment-classes';

class BaseCommentsStore {
    loading;
    visible;

    comments;
    expanded; // global state for comments
    filters;

    get filteredComments () {
        return this.comments
            .filter(c => this.filters.resolved
                ? !c.resolved
                : true)
            .sort((a, b) => a.id < b.id ? 1 : -1);
    };

    get canComment () {
        return Settings.user.isAuthenticated;
    };

    get allowComments () {
        return this.root.file.sharingInfo && this.root.file.sharingInfo.allowComments;
    };

    constructor (root) {
        makeObservable(this, {
            loading: observable,
            visible: observable,
            comments: observable,
            expanded: observable,
            filters: observable,
            filteredComments: computed,
            canComment: computed,
            allowComments: computed,
            add: action,
            removeComment: action,
            replaceComment: action
        });

        this.root = root;
        this.comments = [];
        this.expanded = false;
        this.filters = {
            resolved: true
        };
    };

    create = comment => new Comment(comment);

    add = comment => !this.getComment(comment.id) && this.comments.push(new Comment(comment));

    removeComment = id => {
        this.comments = this.comments.filter(c => c.id !== id);
    };

    replaceComment = newComment => {
        this.removeComment(newComment.id);
        this.add(newComment);
    };

    getComment = id => {
        return this.comments.find(c => c.id === id);
    };
}

export default BaseCommentsStore;
